"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureNodeCanvasTextCorrection = void 0;
var toFontProperty_1 = require("./toFontProperty");
/**
 * Measured in Chrome as follows:
 *
 * - Render text "HELLO" at a large size (Open Sans)
 * - $offset = measure distance between y=0 and top of "L"
 * - $height = measure height of "L"
 * - Divide $offset by $height
 * - Add to 1
 */
var MAGIC_NUMBER = 1.066;
exports.measureNodeCanvasTextCorrection = function (textToMeasure, device) {
    var fontSize = textToMeasure.fontSize, content = textToMeasure.content;
    var canvas = device.createCanvas("bitmap");
    canvas.width = 5000;
    canvas.height = fontSize * MAGIC_NUMBER;
    var ctx = canvas.getContext("2d");
    ctx.font = toFontProperty_1.toFontProperty(textToMeasure);
    ctx.textBaseline = "middle";
    ctx.fillText(content, 0, 0.5 * canvas.height);
    var image = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var top = findTop(image.data, canvas.width, canvas.height);
    return -1 * ((top / fontSize * 0.5) * fontSize);
};
var findTop = function (imageData, width, height) {
    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            var colors = rgbaIndices(x, y, width).map(function (index) { return imageData[index]; });
            if (colors.some(function (c) { return c > 0; })) {
                return y;
            }
        }
    }
    throw new Error("No colored pixels found in correction sample");
};
var rgbaIndices = function (x, y, width) {
    var red = y * (width * 4) + x * 4;
    return [red, red + 1, red + 2, red + 3];
};
//# sourceMappingURL=measureNodeCanvasTextCorrection.js.map